const KeenSlider = window.KeenSlider

const { setInitialised, useA11y, useArrows } = window.BAO.Carousel.plugins

class ShopLook extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.els?.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleOpen)
    })

    this.els?.close?.elements.forEach((closeEl) => {
      this.listeners.add(closeEl, 'click', this.handleClose)
    })
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2,
          spacing: 10,
        },
        slideChanged: (instance) => {
          const activeIndex = instance.track.details.rel

          this.els.slide.elements.forEach((slideEl) => {
            slideEl.setAttribute(
              'aria-hidden',
              slideEl.dataset.index !== activeIndex.toString(),
            )
          })
        },
      },
      [
        setInitialised(),
        useA11y({
          instructions: null,
        }),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  handleOpen () {
    document.body.classList.toggle('util-SiteOverfloewd', true)
    this.els.modal.element.showModal()
  }

  handleClose () {
    this.els.modal.element.close()
    document.body.classList.toggle('util-SiteOverflowed', false)
  }
}

if (!customElements.get('shop-look')) {
  customElements.define('shop-look', ShopLook)
}
